/* pawty-nb-ugc-toggle.js
   "See the toys in action" -- flips every pawty-nb-product-card on the
   page between its photo and looping UGC video (assets/pawty-nb-product-
   card.css, .pawty-ugc-mode). There can be more than one toggle instance
   on a single page (collection toolbar, homepage popular-products tabs,
   etc.) -- they all stay in sync via the shared .pawty-ugc-mode class on
   <body>, and this script re-binds any toggles/videos that show up later
   (e.g. a new page of products loaded in via "Load more"). */
(function () {
  /* Only ever play/fetch videos that are actually near the viewport --
     an earlier version called .play() on EVERY [data-ugc-video] on the
     page the instant the toggle flipped on, regardless of visibility.
     On a full collection grid (24+ cards) that meant 20+ simultaneous
     multi-MB video downloads competing for bandwidth, which stalled and
     stuttered the one video the visitor was actually looking at -- got
     WORSE the longer the toggle stayed on, as more videos piled onto the
     connection. An IntersectionObserver lets each video start loading
     only as it scrolls into view (with a little lead-in room so it's
     already playing by the time it's fully on screen) and pause again
     once it scrolls away, freeing that bandwidth back up. */
  var observedVideos = new WeakSet();
  var io = null;
  var VIEWPORT_MARGIN = 200; /* px lead-in/out, keep in sync with rootMargin below */

  function isOn() {
    return document.body.classList.contains('pawty-ugc-mode');
  }

  function getObserver() {
    if (io) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!isOn()) return;
        var video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(function () {
            /* Autoplay blocked -- the card just shows a static first frame
               instead, no fallback needed since the photo is still there
               underneath at full opacity until this succeeds. */
          });
        } else {
          video.pause();
        }
      });
    }, { rootMargin: VIEWPORT_MARGIN + 'px 0px' });
    return io;
  }

  function nearViewport(video) {
    var rect = video.getBoundingClientRect();
    return rect.top < window.innerHeight + VIEWPORT_MARGIN && rect.bottom > -VIEWPORT_MARGIN;
  }

  function observeVideo(video) {
    if (observedVideos.has(video)) return;
    observedVideos.add(video);
    getObserver().observe(video);
  }

  function setMode(on) {
    document.body.classList.toggle('pawty-ugc-mode', on);
    document.querySelectorAll('[data-ugc-toggle]').forEach(function (input) {
      input.checked = on;
    });
    document.querySelectorAll('[data-ugc-video]').forEach(function (video) {
      /* Start observing every video regardless of on/off -- once a video
         has been seen here, scrolling it into view later (while the mode
         is on) is handled entirely by the observer callback above. */
      observeVideo(video);
      if (on) {
        /* Videos already observed from a previous "on" session won't get
           a fresh initial callback just from being in observedVideos, so
           explicitly kick off anything already on/near screen right now;
           the observer takes over for everything scrolled to afterward. */
        if (nearViewport(video)) {
          video.play().catch(function () {});
        }
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-ugc-toggle]')) return;
    setMode(event.target.checked);
  });

  /* The theme dispatches this on <body> after any AJAX content swap --
     both a facet/sort re-render AND a "Load more" page append (see
     facets.min.js: both paths call dispatchEvent(new CustomEvent(
     "products:update")) once the new HTML is in the DOM). Cards that
     load in that way are brand new elements that never received the
     initial setMode() call, so their [data-ugc-toggle] sits at its
     default unchecked state and their video was never observed -- calling
     setMode() again picks up the new elements the same way it does on
     first load (observeVideo() no-ops for cards already tracked, so this
     can't double-observe/double-play anything that was already running). */
  document.addEventListener('products:update', function () {
    setMode(document.body.classList.contains('pawty-ugc-mode'));
  });
})();